import api from '@/api/api';
import router from '@/router';
import UploadFile from '@/shared/services/oss.service';
import { isNull } from '@/shared/utils/utils';
import moment from 'moment';
import { Field, Icon, CellGroup, DatetimePicker, Popup, Form, Uploader, Button, Toast } from 'vant';
import { Component, Vue } from 'vue-property-decorator';
import FormItemCard from './../shared/components/form-item-card/form-item-card.vue';
@Component({
  components: {
    'FormItemCard': FormItemCard,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Uploader.name]: Uploader,
    [Button.name]: Button
  }
})
export default class ConfirmMobileAccept extends Vue {

  minDate: Date = new Date(1960, 0, 1);

  offerId: any;
  data: any = {};

  // 日期弹窗的值
  dateValues: any = {};
  // 日期弹窗的状态
  dateShowState: any = {};

  // 上传附件的值
  fileValues: any = {};

  // 入职模板
  dataTemplate: any = {
    entryDate: false,
    medicalInfo: false,
    registry: false,
    computerUse: false,
    physicalExamination: false,
    salaryTurnover: false,
    criminalCertificate: false
  };

  submitting: boolean = false;

  get showUploadGroup() {
    return this.dataTemplate['registry'] || this.dataTemplate['physicalExamination'] || this.dataTemplate['salaryTurnover'] || this.dataTemplate['criminalCertificate'];
  }

  mounted() {
    this.offerId = this.$route.query.offerId;
    // OF9999999998
    api.getConfirmJsonByOfferId(this.offerId).then(
      (res: any) => {
        console.log(res.json);
        const templates = JSON.parse(res.json);
        const parseTemplate: any = {};
        for (let template of templates) {
          if (template.checked) {
            parseTemplate[template.LabelName] = true;
          }
        }
        this.dataTemplate = parseTemplate;
      }
    )
  }

  submit() {
    if (this.submitting) {
      return;
    }
    if (this.dataTemplate['computerUse'] && isNull(this.data['computerUse'])) {
      Toast.fail('电脑使用选择为必填项');
      return;
    }
    if (this.dataTemplate['needDormitory'] && isNull(this.data['isReplyStay'])) {
      Toast.fail('是否住宿为必填项');
      return;
    }
    if (this.dataTemplate['registry'] && isNull(this.fileValues['registry'])) {
      Toast.fail('学信网《学历证书电子注册备案表》为必填项');
      return;
    }
    if (this.dataTemplate['physicalExamination'] && isNull(this.fileValues['physicalExamination'])) {
      Toast.fail('体检附件为必填项');
      return;
    }
    if (this.dataTemplate['salaryTurnover'] && isNull(this.fileValues['salaryTurnover'])) {
      Toast.fail('近6个月的工资流水为必填项');
      return;
    }
    if (this.dataTemplate['criminalCertificate'] && isNull(this.fileValues['criminalCertificate'])) {
      Toast.fail('无犯罪记录证明为必填项');
      return;
    }

    this.submitting = true;
    const entity: any = {
      offerId: this.offerId,
      entryDate: this.data['entryDate'],
      computerUseChoise: this.data['computerUse'],
      physicalExamination: {
        name: this.data.name,
        phoneNumber: this.data.phoneNumber,
        birthYear: this.data.birthYear,
        age: this.data.age
      },
      offerReplyFiles: this.getFiles(),
      isAccept: true,
      refuseReason: '',
      isReplyStay: this.data.isReplyStay
    }
    // console.log(entity);
    api.confirmOffer(entity).finally(
      () => {
        this.submitting = false;
      }
    ).then(
      res => {
        router.push(`/submit-success?type=1`);
      }
    )
  }

  getFiles() {
    const fileTypes: any = {
      registry: '1',
      physicalExamination: '2',
      salaryTurnover: '3',
      criminalCertificate: '4'
    }
    const fileList = [];
    for (let key of Object.keys(fileTypes)) {
      const files = this.fileValues[key] || [];
      if (files.length === 1) {
        fileList.push({
          fileURL: files[0].url,
          fileClassFily: fileTypes[key]
        })
      }
    }
    return fileList;
  }



  // 自定义文件上传
  afterFileRead(file: any, detail: { name: string }) {
    let fileName = '';
    if (detail.name == 'registry') {
      let suffix: string = file.file.name.split('.').slice(-1)[0];
      fileName = ['学历证书电子注册备案表', suffix].join('.');
    }
    if (detail.name == 'physicalExamination') {
      let suffix: string = file.file.name.split('.').slice(-1)[0];
      fileName = ['体检报告', suffix].join('.');
    }
    if (detail.name == 'salaryTurnover') {
      let suffix: string = file.file.name.split('.').slice(-1)[0];
      fileName = ['工资流水', suffix].join('.');
    }
    if (detail.name == 'criminalCertificate') {
      let suffix: string = file.file.name.split('.').slice(-1)[0];
      fileName = ['无犯罪记录证明', suffix].join('.');
    }
    this.fileValues[detail.name] = [{
      url: '',
      status: 'uploading',
      message: '上传中...'
    }];
    UploadFile.addFileAliyun(file.file, fileName).then(
      (res: any) => {
        this.data[detail.name] = res.url;
        this.fileValues[detail.name] = [{
          url: res.url,
          status: 'done'
        }];
      }
    )
  }

  // 删除文件
  beforeFiledelete(file: any, detail: { name: string }) {
    this.data[detail.name] = '';
    this.fileValues[detail.name] = [];
  }



  // 电脑使用选择
  computerChecked(val: string) {
    this.data.computerUse = val;
    this.data = Object.assign({}, this.data);
  }

  // 是否住宿选择
  isReplyStayChecked(val: string) {
    this.data.isReplyStay = val;
    this.data = Object.assign({}, this.data);
  }

  // 日期输入框点击
  timeControlOnClicked(field: string) {
    let date = this.data[field];
    if (isNull(date)) {
      date = new Date();
    }
    this.dateValues[field] = new Date(date);
    this.dateShowState[field] = true;
    this.dateShowState = Object.assign({}, this.dateShowState);
  }

  // 日期框点击取消
  timePopupOnCancel(field: string) {
    this.dateShowState[field] = false;
    this.dateShowState = Object.assign({}, this.dateShowState);
  }

  // 日期框点击确认
  timePopupOnConfirm(val: any, field: string) {
    this.data[field] = moment(val).format('YYYY-MM-DD');
    this.timePopupOnCancel(field);
  }
}